import { render, staticRenderFns } from "./productTemplate.vue?vue&type=template&id=0ef6af40&scoped=true"
import script from "./productTemplate.vue?vue&type=script&lang=js"
export * from "./productTemplate.vue?vue&type=script&lang=js"
import style0 from "./productTemplate.vue?vue&type=style&index=0&id=0ef6af40&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef6af40",
  null
  
)

export default component.exports